<template>
  <v-container style="height: 90vh; overflow: auto; padding: 10px">
    <template v-if="!contents.length == 0">
      <content-list :items="contents" @input="selectHandler" :layout="'training'" defaultSort="name" />
    </template>
    <template v-else>
      <v-alert v-if="loading" :value="true" color="info" icon="mdi-information-outline">Loading data</v-alert>
      <div v-else :value="true" class="empty_folder">
        <v-img height="500" contain :src="require('@/assets/empty_folder.svg')"></v-img>
        <h5 class="text-center headline font-weight-light mt-5">No collections to show</h5>
      </div>
    </template>
  </v-container>
</template>
<script>
import store from "./store"
import { mapState, mapActions } from "vuex"
import { ContentList } from "plant-common"
import { STORE_LIBRARY_NAME, ACTION_SELECT_PLANT, STATE_PLANT_ID } from "@/store_constants/library"
import { STORE_USER_NAME } from "@/store_constants/user"
import { getContentId } from "../../utils/dbTool"

export default {
  props: {
    library_id: String
  },
  components: {
    ContentList
  },
  beforeCreate() {
    if (!this.$store.state.collection) this.$store.registerModule("collection", store)
  },
  beforeDestroy() {
    if (this.$store.state.collection) this.$store.unregisterModule("collection")
  },
  computed: {
    ...mapState(STORE_LIBRARY_NAME, {
      plant_id: STATE_PLANT_ID
    }),
    ...mapState("collection", ["contents", "loading"])
  },
  methods: {
    ...mapActions(STORE_LIBRARY_NAME, {
      selectPlant: ACTION_SELECT_PLANT
    }),
    ...mapActions("collection", ["getAllCollections"]),
    ...mapActions(STORE_USER_NAME, {}),
    selectHandler(element) {
      if (element._id && !this.loading) {
        let routeData = this.$router.resolve({
          name: "Content Viewer Latest",
          params: { id: getContentId(element), library_id: this.plant_id }
        })
        window.open(routeData.href, "_blank")
      }
    }
  },
  watch: {
    library_id: {
      immediate: true,
      async handler() {
        await this.selectPlant(this.library_id)
        await this.getAllCollections()
      }
    }
  }
}
</script>
<style scoped>
.empty_folder {
  margin: 50px auto;
}
</style>
